import { render, staticRenderFns } from "./CalendarTab.vue?vue&type=template&id=39851db8&scoped=true&lang=pug"
import script from "./CalendarTab.vue?vue&type=script&lang=ts"
export * from "./CalendarTab.vue?vue&type=script&lang=ts"
import style0 from "./CalendarTab.vue?vue&type=style&index=0&id=39851db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39851db8",
  null
  
)

export default component.exports